module.exports = __webpack_public_path__ + "static/media/Flydubai.150e7d68.png";